export default __webpack_public_path__ + "resources/icons/n212-1b82.png";